var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"mb-3",attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"2","md":"1","lg":"1","xl":"1"}},[_c('v-btn',{attrs:{"icon":"","color":"primary","title":"Regresar"},on:{"click":_vm.returnToTable}},[_c('v-icon',[_vm._v("mdi-arrow-left")])],1)],1),_c('v-col',[_c('h2',[_vm._v(_vm._s(_vm.title))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }